export default "__VITE_ASSET__OekgS$Ga__"